/**
 * Site origin from Laravel <meta name="czechvignette-base-url"> or window.location.
 */
export function appBaseUrl() {
    if (typeof document !== 'undefined') {
        const meta = document.querySelector('meta[name="czechvignette-base-url"]');
        const raw = meta?.getAttribute('content')?.trim();
        if (raw) {
            return raw.replace(/\/$/, '');
        }
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin.replace(/\/$/, '');
    }

    return '';
}

/**
 * Turn a public path or CMS URL into an absolute https URL on this site.
 *
 * @param {string|null|undefined} path
 * @returns {string}
 */
export function publicAssetUrl(path) {
    if (path == null) {
        return '';
    }

    let value = String(path).trim();
    if (!value) {
        return '';
    }

    if (value.startsWith('http://')) {
        value = `https://${value.slice(7)}`;
    }

    if (/^https:\/\//i.test(value)) {
        return value;
    }

    if (value.startsWith('//')) {
        return `https:${value.slice(2)}`;
    }

    const relative = value.startsWith('/') ? value : `/${value}`;
    // Prefer the page origin so static assets load from the host serving the HTML.
    const base =
        typeof window !== 'undefined' && window.location?.origin
            ? window.location.origin.replace(/\/$/, '')
            : appBaseUrl();

    return base ? `${base}${relative}` : relative;
}
